import { PureComponent, ReactNode } from 'react';
import { Popover } from 'antd';

type FeedbackType = 'positive' | 'negative' | 'skip';

const ID = 'support-tickets-feedback-popover-button';

interface Props {
    onFeedback: (type: FeedbackType, value?: string) => void;
}

interface State {
    visible: boolean;
    input: string;
}

class FeedbackPopover extends PureComponent<Props, State> {
    initialState: State = {
        visible: false,
        input: '',
    };
    state: State = this.initialState;

    onVisibleChange = (visible: boolean, skip?: boolean): void => {
        const { onFeedback } = this.props;
        this.setState({
            visible: visible,
        });
        if (!visible) onFeedback(skip ? 'skip' : 'negative');
    };

    onChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
        this.setState({
            input: e.target.value,
        });
    };

    onSubmit = (): void => {
        const { onFeedback } = this.props;
        const { input } = this.state;
        const { initialState } = this;
        onFeedback('negative', input);
        this.setState(initialState);
    };

    onSkip = (): void => {
        const { onVisibleChange, initialState } = this;
        onVisibleChange(false, true);
        this.setState(initialState);
    };

    render(): ReactNode {
        const { children } = this.props;
        const { visible, input } = this.state;
        const { onVisibleChange, onChange, onSubmit, onSkip } = this;

        return (
            <Popover
                content={
                    <div className="p-16 rounded-8 space-y-8">
                        <p className="text-13 font-700">Your feedback matters to us!</p>
                        <textarea
                            className="w-320 h-72 mt-12 resize-none border border-neutral-7 rounded-8 px-12 py-10"
                            placeholder="Please tell us your feedabck here..."
                            value={input}
                            onChange={onChange}
                        />
                        <div className="space-x-8">
                            <button
                                className="px-8 py-6 text-12 font-700 text-white bg-darwin-accent-bright-blue-800 border border-darwin-accent-bright-blue-800 rounded-4 disabled:opacity-70 disabled:cursor-not-allowed"
                                onClick={onSubmit}
                                disabled={!input?.trim()}
                            >
                                Submit
                            </button>
                            <button
                                className="px-8 py-6 text-12 font-700 text-darwin-accent-bright-blue-800 border border-darwin-accent-bright-blue-800 rounded-4"
                                onClick={onSkip}
                            >
                                Skip
                            </button>
                        </div>
                    </div>
                }
                title={null}
                trigger={'click'}
                overlayClassName="popover-p-0 patient-health-summary-popover patient-health-summary-feedback-popover"
                placement="topLeft"
                visible={visible}
                onVisibleChange={onVisibleChange}
                destroyTooltipOnHide
                getPopupContainer={() => document.getElementById(ID) || document.body}
            >
                <div id={ID}>{children}</div>
            </Popover>
        );
    }
}

export default FeedbackPopover;
